export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjY0ODMzMTk5LTk0MDEtMTFlMy04Zjc0LTAwMjE5YjhiNTA0NyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.yJIHhpQTn97zzuddGb078ovnIYHyQrI6JcUbOeVIwNIt84xiS08TKwJiIAGYIwZ9L4sIxBuFzeLUBdVAzDBW4834FY5sg1tgyw/lPITJkGVU1bmUsefKVvYfDRQmnOR04oCi0g==';
